export const KEY_PARAM_MODAL = 'modal';
export const CHECK_DEPOSIT_ID = 'checkId';
export const COUNTERPARTY_ID = 'counterpartyId';
export const IDEMPOTENCY_KEY = 'idempotencyKey';
export const FORCE_MFA = 'forceMfa';
export const MFA_VERIFIED = 'mfaVerified';
export const PLAID_CALLBACK = 'plaidCallback';

export const MODAL_NAMES = {
  BOA_MODAL: 'boa-modal', // Bank of America Modal
  PAYEES_MODAL: 'payees',
  LINKED_MODAL: 'linkedaccounts',
  APPLICATION_INIT_MODAL: 'application-init',
  AWAITING_DOCUMENTS: 'awaiting-documents',
  APPLICATION_SUBMISSION_MODAL: 'application-submission',
  LINK_BANK_ACCOUNT_MODAL: 'link-bank-account',
  APPLICATION_RECEIVED_MODAL: 'application-received',
  DEBIT_CARD_MAILING: 'debit-card-mailing',
  STATEMENTS: 'statements',
  RETRY_CHECK_DEPOSITS: 'retry-check-deposits',
  ACTIVATE_CARD: 'activate-card',
  FREEZE_CARD_MODAL: 'freeze-card',
  UNFREEZE_CARD_MODAL: 'unfreeze-card',
  CONFIRM_DELETE_PAYEE_MODAL: 'confirm-delete-payee-modal',
  SET_PIN_MODAL: 'set-pin',
  RESET_PIN_MODAL: 'reset-pin-modal',
  UPLOAD_DOCUMENTS_MODAL: 'upload-documents-modal',
  DEPOSIT_MODAL: 'funds-bank-account',
  WITHDRAW_MODAL: 'withdraw-modal',
  TRANSFER_MODAL: 'transfer-modal',
  CREATE_NEW_CARD_MODAL: 'request-new-card-modal',
  TRANSACTION_HISTORY_MODAL: 'transaction-history-modal',
  ENTER_EIN_MODAL: 'enter-ein',
  CANCEL_PAYMENT_MODAL: 'cancel-payment-modal',
  VIEW_PDF_MODAL: 'view-pdf',
  CHECK_DEPOSIT_MODAL: 'check-deposit',
  IMAGE_VIEW_MODAL: 'image-view',
  DEPOSIT_CHOICE_VIEW_MODAL: 'deposit-choice-view',
  CHECK_DEPOSIT_EDUCATION_MODAL: 'check-deposit-education',
  CHECK_DEPOSIT_EXIT_CONFIRM_MODAL: 'check-deposit-exit-confirm-modal',
  CHECK_DEPOSIT_HISTORY: 'checks-history',
  BANKING_VIDEO: 'banking-video',
  BANKING_UPSELL: 'banking-upsell',
  MOVE_MONEY_CHOICE_VIEW_MODAL: 'move-money-choice-view',
  SEND_MONEY_MODAL: 'send-money-modal',
  DEPOSIT_MONEY_MODAL: 'deposit-money-modal',
  NOT_SUPPORTED_INSTANT_DEPOSIT_MODAL: 'not-supported-instant-deposit',
  SEND_MONEY: 'send-money',
  MOVE_MONEY_MODAL: 'move-money',
  DEPOSIT_MONEY: 'deposit-money',
  CARD_MODAL: 'card-modal',
  ADD_CARD_WALLET_MODAL: 'add-card-wallet-modal',
  CHECK_DEPOSIT_RESUBMIT_MODAL: 'check-deposit-resubmit-modal',
  INSTANT_DEPOSIT_MODAL: 'instant-deposit',
  SCAN_TO_DOWNLOAD_APP_MODAL: 'scan-to-download-app-modal',
  DOWNLOAD_APP_MODAL: 'download-app-modal',
  ADDITIONAL_INFO_MODAL: 'additional-info-modal',
  ADDITIONAL_INFO_EXIT_CONFIRM_MODAL: 'additional-info-exit-confirm-modal'
};
